import { JwtModuleOptions } from '@auth0/angular-jwt';

export const JWT_TOKEN_STORAGE_KEY = 'mediego_jwt';

export const JWT_MODULE_CONFIG: JwtModuleOptions = {
  config: {
    tokenGetter: () => localStorage.getItem(JWT_TOKEN_STORAGE_KEY),
    allowedDomains: [
      '127.0.0.1',
      '127.0.0.1:9000',
      '127.0.0.1:9001',
      '127.0.0.1:9002',
      '127.0.0.1:9003',
      'localhost',
      'localhost:9000',
      'localhost:9001',
      'localhost:9002',
      'localhost:9003',
      'mediego.pro',
      'mediego.com',
      'api.mediego.com',
      'api-qual.mediego.com'
    ],
    disallowedRoutes: [
      RegExp('.*\/api\/login'),
      RegExp('.*\/api\/signup'),
      RegExp('.*\/api\/accept-invite')
    ]
  }
};

export interface MediegoJwt {
  email: string;
  superAdmin: boolean;
  // Date d'expiration du token
  exp?: number;
}
